import React, { useState, useEffect } from 'react'
import GenericResponseModals from '../generic-response-modals/generic-response-modals'
import { errorEmitter } from '../../../services/axios-instance'
import './global-error-modal.scss'

const GlobalErrorModal = () => {
  const [error, setError] = useState(null)

  useEffect(() => {
    const handleError = (event) => {
      setError(event.detail.message)
    }

    errorEmitter.addEventListener('apiError', handleError)
    return () => errorEmitter.removeEventListener('apiError', handleError)
  }, [])

  const closeModal = () => {
    setError(null)
  }

  if (!error) return null

  return (
    <div className="f-global-error-modal">
      <GenericResponseModals
        title="Error"
        subtitle={error}
        copyBtn="Aceptar"
        closeModal={closeModal}
        onClickBtn={closeModal}
      />
    </div>
  )
}

export default GlobalErrorModal
